import type { FaireProductEntity } from "../../entity_types/product";

export const p_7zpk6kej99: FaireProductEntity = {
  token: "p_7zpk6kej99",
  type: "product",
  name: "Campfire Coffee Candle - 100% Soy Wax - Nontoxic ",
  brandName: "Woodsy Wicks",
  imageUrl:
    "https://cdn.faire.com/fastly/b9274f53fcc725d15db97095171ae80c2dee4d0f76fd579ac32f02b38c260bf4.jpeg",
  priceDollars: 6,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/f0fc7cbc406e1fdd672636cd042942916d727a807fd406455e856efc6c980535.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
